"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const images_1 = require("../../assets/images");
const helpler_1 = require("../../utils/helpler");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const ModalMaintaining = () => {
    const visible = (0, react_redux_1.useSelector)((state) => state.appReducer.isMaintaining);
    return (react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: "none", statusBarTranslucent: true, transparent: true, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        } },
        react_1.default.createElement(react_native_1.View, { style: styles.container },
            react_1.default.createElement(react_native_1.View, { style: styles.box },
                react_1.default.createElement(react_native_1.Image, { source: images_1.images.LogoTitle, style: styles.logo }),
                react_1.default.createElement(CustomText_1.default, { weight: '600', style: styles.title }, "\u305F\u3060\u3044\u307E\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u4E2D\u3067\u3059"),
                react_1.default.createElement(CustomText_1.default, { style: styles.description }, 'メンテナンスが終了するまで\nもうしばらくお待ちください。'),
                react_1.default.createElement(CustomText_1.default, { weight: '600', style: [styles.title, { marginTop: (0, scale_1.scale)(8) }] }, '【終了予定時刻】\n2024年4月16日　11時00分')))));
};
exports.default = ModalMaintaining;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Colors_1.default.textHeaderOpacity60,
        justifyContent: 'center',
        alignItems: 'center',
    },
    box: {
        width: (0, scale_1.scale)(343),
        paddingHorizontal: (0, scale_1.scale)(16),
        paddingVertical: (0, scale_1.scale)(24),
        backgroundColor: '#FEFEFE',
        borderRadius: (0, scale_1.scale)(12),
    },
    logo: {
        width: (0, scale_1.scale)(110),
        height: (0, scale_1.scale)(24),
        alignSelf: 'center'
    },
    title: {
        marginTop: (0, scale_1.scale)(24),
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        color: '#292A33',
        textAlign: 'center',
    },
    description: {
        marginTop: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#292A33',
        textAlign: 'center'
    },
    primaryButton: {
        width: '100%',
        height: (0, scale_1.scale)(48),
        borderRadius: (0, scale_1.scale)(4),
    },
    primaryButtonLabel: {
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        color: '#FEFEFE'
    },
    cancelButton: {
        alignSelf: 'center',
        marginTop: (0, scale_1.scale)(20),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#007AFF'
    }
});
